import { render } from "./auth-layout.vue?vue&type=template&id=ec1c5ec8&ts=true"
import script from "./auth-layout.vue?vue&type=script&lang=ts"
export * from "./auth-layout.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.9.5__webpack@5.99.7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__